import MasterService from "./MasterService";

const EncryptionService = {
    ...MasterService,

    fetchPublicKey() {
        return this.post('/user/get_public_key')
    }
}

export default EncryptionService
